<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template #title>POS: Terminate Employee</template>

        <slot>
            <div>
                <form @submit.prevent="onSubmit()">
                    <p>
                        This will terminate the employee in <b>Altametrics</b>.
                    </p>

                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col">
                            <form-input label="Termination Date" v-model="formData.termination_date" :errors="errors.termination_date" type="date" helper-text="Must be AFTER the last punch date" />
                        </div>
                    </div>

                    <div class="form-row" v-if="employee.employment_status != 'Terminated'">
                        <div class="col">
                            <form-input label="Terminate in Payroll" v-model="formData.terminate_in_payroll" :errors="errors.terminate_in_payroll" type="checkbox" />
                        </div>
                    </div>

                    <div v-if="formData.terminate_in_payroll" class="mt-2 p-2 border">
                        <div class="form-row">
                            <div class="col">
                                <form-input label="Eligible for Rehire" v-model="formData.eligible_for_rehire" :errors="errors.eligible_for_rehire" type="checkbox" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col mt-2">
                                <form-input label="Termination Reason" v-model="formData.termination_reason" :errors="errors.termination_reason" type="select" :options="terminationReasonOptions"/>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </slot>

        <template #footer>
            <div class="form-row mt-2">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Terminate Employee</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import api from '@/api'
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'
import moment from 'moment'

export default {
    mixins: [ModalMixin, FormMixin],
    props: ['client', 'employee', ],
    data() {
        const date_latest = moment().add(364, 'days')

        const terminationReasonOptions = []
        this.client.termination_reasons.forEach((option) => {
            terminationReasonOptions.push({
                text: option,
                value: option,
            })
        })

        const data = {
            formRules: {
                termination_date: {presence: {allowEmpty: false}, date: {latest: date_latest, tooLate: "can't be more than a year from today."}},
                termination_reason: {presence: {allowEmpty: false}},
            },
            formData: this.makeFormData(),
            formRules: {
                termination_date: {presence: {allowEmpty: false},},
            },
            terminationReasonOptions: terminationReasonOptions,
        }

        return data
    },
    methods: {
        makeFormData() {
            const formData = {
                termination_date: moment(),
                terminate_in_payroll: false,
                eligible_for_rehire: true,
                termination_reason: '',
            }

            return formData
        },

        onSubmit(evt) {
            if (!this.validate()) {
                return
            }

            const url = `/clients/${this.client.id}/employees/${this.employee.id}/pos-actions/terminate`;
            this.$store.dispatch('START_LOADING')
            this.$api.post(url, this.getFormData()).then(() => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo("Sent to POS", "Sent to Altametrics. This may take several minutes.")
                this.$emit('close')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    }
}
</script>
